import * as React from 'react';
import { useIsMobile } from '@/mediaQueriesHelpers';
import styles from '../styles/dashboardStyles';
import { Layout } from 'antd/lib';
import { Route, Switch } from 'react-router-dom';
import routes from '@/routes';
import { PublicBuildDistroContainer } from './PublicBuildDistro';

export const PublicAppContainer = () => {
    const isMobile = useIsMobile();

    return (
        <div
            style={{
                ...styles.dashboardContainerStyle,
                ...(isMobile ?
                    {
                        flexDirection: 'column',
                        overflowY: 'scroll',
                    }
                :   {}),
                ...{
                    height: '100vh',
                },
            }}
        >
            <div
                style={{
                    ...styles.containerStyle,
                }}
            >
                <Layout>
                    <Switch>
                        <Route
                            path={[routes.publicBucket, routes.publicBuild]}
                            component={PublicBuildDistroContainer}
                        />
                    </Switch>
                </Layout>
            </div>
        </div>
    );
};
